import { logAppError } from 'Helpers/logger'
import { atom, selector, selectorFamily } from 'recoil'

import { TEMPLATE_TYPE_LOCAL } from 'Constants/index'

import { generateThumbnail } from '../actions/actions'

export const resultsState = atom({
  key: 'templateListResults',
  default: {
    items: [],
    totalItems: 0,
    searchParams: {}
  }
})

export const thumbnailState = selectorFamily({
  key: 'templateListThumbnailState',
  get: idTemplate => ({ get }) => {
    const { items } = get(resultsState)
    const item = items.find(({ id }) => id === idTemplate)

    return item
  },
  set: idTemplate => ({ set }, newValue) => {
    set(resultsState, prev => ({
      ...prev,
      items: prev.items.map(o =>
        o.id === idTemplate
          ? {
              ...o,
              ...newValue
            }
          : o
      )
    }))
  }
})

export const resultsStateEmptyState = selector({
  key: 'templateListResultsStateEmptyState',
  get: ({ get }) => {
    const {
      items,
      searchParams: { type, searchText }
    } = get(resultsState)

    return type === TEMPLATE_TYPE_LOCAL && !searchText && !items.length
  }
})

export const resultsTemplateHasThumb = selectorFamily({
  key: 'messageListResultThumbByMessageId',
  get: id => async ({ get }) => {
    const {
      items,
      searchParams: { type }
    } = get(resultsState)

    const { thumbnail, hasThumbnail } = items.find(item => item.id === id)

    if (!hasThumbnail) {
      try {
        const newThumbnail = await generateThumbnail(type, id)
        return {
          result: true,
          thumbnail: `${newThumbnail}?ts=${Date.now()}`
        }
      } catch (error) {
        logAppError({ appError: error })
        throw error
      }
    }

    return { result: true, thumbnail }
  }
})
